import axios from 'axios';
import FileSaver from 'file-saver';

export async function HandleCreateCourseReport(report) {
    const url = 'api/exlReportFront/createCourseReport/';

    const res = await axios.post(url, report, {responseType: 'blob', }).then(
        (response) => {
            if (response.status === 200) {
                FileSaver.saveAs(response.data, `excellerate_report.xlsx`);
                return { success: true, error: null, data: response.data };
            } else {
                return {
                    success: false,
                    error: response.data.message,
                    data: null,
                };
            }
        },
        (error) => {
            return {
                success: false,
                error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.',
                data: null,
            };
        }
    );
    return res;
}
export async function HandleCreateCertificateReport(report) {
    const url = 'api/exlReportFront/createCertificateReport/';

    const res = await axios.post(url, report, { responseType: 'blob', }).then(
        (response) => {
            if (response.status === 200) {
                FileSaver.saveAs(response.data, `excellerate_report.xlsx`);
                return { success: true, error: null, data: response.data };
            } else {
                return {
                    success: false,
                    error: response.data.message,
                    data: null,
                };
            }
        },
        (error) => {
            return {
                success: false,
                error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.',
                data: null,
            };
        }
    );
    return res;
}

export async function HandleCreateTeacherReport(report) {
    const url = 'api/exlReportFront/createTeacherReport/';

    const res = await axios.post(url, report, { responseType: 'blob', })
        .then(
        (response) => {
            if (response.status === 200) {
                FileSaver.saveAs(response.data, `excellerate_report.xlsx`);
                return { success: true, error: null, data: response.data };
            } else {
                return {
                    success: false,
                    error: response.data.message,
                    data: null,
                };
            }
        },
        (error) => {
            return {
                success: false,
                error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.',
                data: null,
            };
        }
    );
    return res;
}